export const sxAppBar = (theme: { palette: { mode: string } }) => ({
  boxShadow: 0,
  bgcolor: "transparent",
  backgroundImage: "none",
  mt: 2,
});
export const sxToolbar = (theme: { palette: { mode: string } }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  borderRadius: "999px",
  bgcolor:
    theme.palette.mode === "light"
      ? "rgba(255, 255, 255, 0.4)"
      : "rgba(0, 0, 0, 0.4)",
  backdropFilter: "blur(24px)",
  maxHeight: 40,
  border: "1px solid",
  borderColor: "divider",
  boxShadow:
    theme.palette.mode === "light"
      ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
      : "0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)",
});
export const sxItemsBox = (theme: { palette: { mode: string } }) => ({
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
  ml: "-18px",
  px: 0,
});
export const sxDrawerBox = (theme: { palette: { mode: string } }) => ({
  minWidth: "60dvw",
  p: 2,
  backgroundColor: "background.paper",
  flexGrow: 1,
});
export const sxDrawerInnerBox = (theme: { palette: { mode: string } }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "end",
  flexGrow: 1,
});
